module.exports = __webpack_public_path__ + "img/checksIcon.2788f641.svg";